import { render } from "./CXClientSettings.vue?vue&type=template&id=d2750e46&scoped=true"
import script from "./CXClientSettings.vue?vue&type=script&lang=js"
export * from "./CXClientSettings.vue?vue&type=script&lang=js"

import "./CXClientSettings.vue?vue&type=style&index=0&id=d2750e46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2750e46"]])

export default __exports__